import type { ReactNode } from "react";

export type BadgeTone = "good" | "warn" | "bad" | "info" | "neutral";

const TONES: Record<BadgeTone, string> = {
  good: "border-emerald-600/30 bg-emerald-600/10 text-emerald-800 dark:text-emerald-300",
  warn: "border-amber-500/40 bg-amber-500/10 text-amber-800 dark:text-amber-300",
  bad: "border-destructive/30 bg-destructive/10 text-destructive",
  info: "border-primary/30 bg-primary/10 text-primary",
  neutral: "border-border bg-muted text-muted-foreground",
};

/** A small status label. The words come from the widget's strings. */
export function Badge({
  tone,
  children,
}: {
  tone: BadgeTone;
  children: ReactNode;
}) {
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full border px-2 py-0.5 font-medium text-xs ${TONES[tone]}`}
    >
      {children}
    </span>
  );
}
